module.exports = __webpack_public_path__ + "static/media/flag-ico-br.c678c507.png";